"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Grid = require("../../Layout/Grid");

var _Constant = require("../../Constant");

var _Constant2 = require("../Constant");

var _Navbar = _interopRequireDefault(require("./Navbar"));

var _hooks = require("../../hooks");

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: block;\n  width: 100%;\n\n  @media print, screen and (min-width: ", "px) {\n    margin-top: 25px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 25px;\n  margin-top: 25px;\n  padding-top: 20px;\n  padding: 0 15px;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  border-top: 1px solid ", ";\n\n  @media print, screen and (min-width: ", "px) {\n    padding: 20px 64px 0 64px;\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    padding-left: unset;\n    padding-right: unset;\n    max-width: 640px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  margin: 75px 0 0;\n  padding: 0 16px;\n  width: 100%;\n\n  /* Reduce top margin when the top nav is not fixed on small devices in landscape mode or when zoomed in */\n  @media print, screen and (max-height: 479px) {\n    margin-top: 20px;\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    padding: 0 64px;\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    padding: unset;\n    margin-top: 0;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 640px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    padding: 0;\n    width: 100%;\n\n    /* Applied when the top nav is not fixed on small devices in landscape mode or when zoomed in */\n    @media print, screen and (max-height: 479px) {\n      margin-left: -8px;\n      margin-right: -8px;\n    }\n\n    @media print, screen and (min-width: ", "px) {\n      flex-basis: 70%;\n      align-self: stretch;\n      padding-left: 15px;\n      padding-right: 15px;\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    margin-top: 24px;\n    padding: 0 15px;\n    width: 100%;\n    margin-bottom: 24px;\n\n    @media print, screen and (min-width: ", "px) {\n      padding: 0 64px;\n    }\n\n    @media print, screen and (min-width: ", "px) {\n      margin-top: unset;\n      padding: unset;\n      max-width: 360px;\n      flex-basis: 25%;\n      min-height: 100%;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  min-height: 100vh;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = (0, _styledComponents.default)(_Grid.Container)(_templateObject(), _Constant2.Color.COTTON_BALL);
var SidebarCol = (0, _styledComponents.default)(_Grid.Col)(_templateObject2(), _Constant.Width.SM, _Constant.Width.MD);
var MainCol = (0, _styledComponents.default)(_Grid.Col)(_templateObject3(), _Constant.Width.MD);

var MainContainer = _styledComponents.default.div(_templateObject4(), _Constant.Width.SM, _Constant.Width.MD);

var FooterContainer = _styledComponents.default.footer(_templateObject5(), function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor || _Constant2.Color.GREY_4;
}, _Constant.Width.SM, _Constant.Width.MD);

var MainContent = _styledComponents.default.main(_templateObject6(), _Constant.Width.MD);

var TwoColumn = function TwoColumn(_ref2) {
  var url = _ref2.url,
      menuList = _ref2.menuList,
      renderMainContent = _ref2.renderMainContent,
      renderSidebar = _ref2.renderSidebar,
      renderFooter = _ref2.renderFooter,
      containerPadding = _ref2.containerPadding,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["url", "menuList", "renderMainContent", "renderSidebar", "renderFooter", "containerPadding"]);

  var _useBreakpoints = (0, _hooks.useBreakpoints)(),
      breakpoint = _useBreakpoints.breakpoint;

  var isMobile = breakpoint === _Constant.Breakpoint.SM || breakpoint === _Constant.Breakpoint.XS;

  var Footer = function Footer() {
    return /*#__PURE__*/_react.default.createElement(FooterContainer, null, renderFooter());
  };

  return /*#__PURE__*/_react.default.createElement(Container, {
    containerPadding: containerPadding
  }, /*#__PURE__*/_react.default.createElement(_Grid.Row, null, /*#__PURE__*/_react.default.createElement(MainCol, null, /*#__PURE__*/_react.default.createElement(_Navbar.default, (0, _extends2.default)({
    url: url,
    menuList: menuList
  }, rest)), /*#__PURE__*/_react.default.createElement(MainContainer, null, /*#__PURE__*/_react.default.createElement(MainContent, null, renderMainContent())), !isMobile && /*#__PURE__*/_react.default.createElement(Footer, null)), !!renderSidebar && /*#__PURE__*/_react.default.createElement(SidebarCol, null, renderSidebar()), isMobile && /*#__PURE__*/_react.default.createElement(Footer, null)));
};

TwoColumn.propTypes = {
  /** Render function to generate the footer. Assumes you want it wrapped in an HTML <footer> tag. */
  renderFooter: _propTypes.default.func,

  /** Render function to generate the main content */
  renderMainContent: _propTypes.default.func,

  /** Render function to generate right sidebar */
  renderSidebar: _propTypes.default.func,

  /** Array of nodes to render when the menu button is clicked */
  menuList: _propTypes.default.arrayOf(_propTypes.default.node),
  url: _propTypes.default.string,
  containerPadding: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
TwoColumn.defaultProps = {
  renderMainContent: function renderMainContent() {
    return null;
  },
  renderSidebar: null,
  renderFooter: function renderFooter() {
    return null;
  },
  menuList: [],
  url: '/dashboard',
  containerPadding: 15
};
var _default = TwoColumn;
exports.default = _default;